<div class="col gap-8"></div>

<div class="chat w100 col gap-16" *ngIf="chat">
  <div class="entry w100 gap-8 col" *ngFor="let item of chat; let i = index">
    @if(item.speaker.indexOf(interview_partner?.name) > -1 ||
    item.speaker.indexOf('xpert') > -1){
    <div class="interview_partner align-center row gap-8">
      <div class="icon" [style]="interview_partner?.image"></div>
      <div class="name tiny">{{ interview_partner?.name }}</div>
    </div>
    <div class="partnertext" markdown ngPreserveWhitespaces>
      {{ item.text }}
    </div>
    <!-- <div
      class="partnertext"
      markdown
      ngPreserveWhitespaces
      *ngIf="item.follow_up_question"
    >
      {{ item.follow_up_question }}
    </div> -->

    }@else {
    <div class="persona align-center row gap-8 w100 justify-end">
      <div class="name tiny">{{ persona?.name }}</div>
      <div class="icon" [style]="persona?.image"></div>
    </div>
    <div class="personatext" markdown ngPreserveWhitespaces>
      {{ item.text }}
    </div>
    } @if(item.options && showSuggestions === true && showOptions === true){
    <div class="suggestions col gap-8 w100">
      <div
        class="suggestion row gap-16 align-center pointer"
        *ngFor="let sug of item.options; let i = index"
        (click)="clickSuggestion(item.text, sug)"
      >
        <div class="roundicon">{{ letters[i] }}</div>
        <div class="suggestion_content" markdown ngPreserveWhitespaces>
          {{ sug.text || sug }}
        </div>
      </div>
    </div>
    }
    <div
      class="btnrow row gap-8"
      *ngIf="
        showOptions === true &&
        showSuggestions === true &&
        (item.speaker.indexOf(interview_partner?.name) > -1 ||
          item.speaker.indexOf('xpert') > -1) &&
        chat?.length - 1 === i
      "
    >
      <rr-btn type="Secondary" iconStart="refresh" (click)="refresh.emit()"
        >Refresh</rr-btn
      >
      <rr-btn
        type="Secondary"
        iconStart="ai"
        (click)="answerForMe(item)"
        *ngIf="item.options?.length > 0"
        >Answer for me</rr-btn
      >
    </div>
  </div>
  @if(showResult === true){
  <div class="selectedsuggestion row gap-8 align-center">
    <rr-icon name="check" class="roundicon"></rr-icon>
    <div class="selectedsuggestion_content" markdown ngPreserveWhitespaces>
      {{ value }}
    </div>
  </div>
  }
</div>
